import { Component, Inject, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EEntityTypes } from '../enums';
import { IUserLogin } from '../interfaces/model';

@Component({
  selector: 'app-confirm-dialog-credentials',
  templateUrl: './confirm-dialog-credentials.component.html',
  styleUrls: ['./confirm-dialog-credentials.component.scss'],
})

export class ConfirmDialogCredentialsComponent implements OnInit {
  message: string;
  type: EEntityTypes;
  isDelete: boolean = true;
  private defaultMessage = `All unsaved changes will be lost if you choose to do so.`;

  constructor(private dialogRef: MatDialogRef<ConfirmDialogCredentialsComponent, IUserLogin | boolean>, @Inject(MAT_DIALOG_DATA)
  public data: {message: string; type: EEntityTypes}) { }

  ngOnInit(): void {
    this.message = this.data.message || this.defaultMessage;
    this.type = this.data.type;
  }

  closeDialog() {
    setTimeout(() => {
      this.dialogRef.close(false);
    }, 1);
  }

  getUserCredentials(credentials: IUserLogin){
    credentials ? this.dialogRef.close(credentials) : this.dialogRef.close(false);
  }

  confirmNavigation() {
    setTimeout(() => {
      this.dialogRef.close(true);
    }, 1);
  }

}
